/* eslint-disable no-param-reassign -- RTK uses Immer; mutating `state` is the intended pattern (matches sibling slices) */
import { createSlice } from '@reduxjs/toolkit'
import { get } from 'lodash'

// Per-map control preferences (basemap, layer toggles, offsets) keyed by a map
// id so each surface keeps its OWN set — e.g. satellite can stick on the
// change-container map while the bulk maps stay on street. Persisted via
// redux-persist (whitelisted in providers/store.js) so it survives reopen +
// session.
const initialState = { byMap: {} }

const persistentMapPreferencesSlice = createSlice({
  name: 'persistentMapPreferences',
  initialState,
  reducers: {
    setMapPreference: (state, { payload: { mapKey, field, value } }) => {
      if (!state.byMap[mapKey]) state.byMap[mapKey] = {}
      state.byMap[mapKey][field] = value
    },
  },
})

export const { setMapPreference } = persistentMapPreferencesSlice.actions

// Returns the stored value or `undefined` when the map hasn't set this field yet
// (callers fall back to their own default).
export const selectMapPreference = (mapKey, field) => state => get(state, ['persistentMapPreferences', 'byMap', mapKey, field])

export default persistentMapPreferencesSlice.reducer
